import React from 'react';

import { Box, Button, Flex, Spacer, Link } from '@chakra-ui/react'
import { InfoIcon } from '@chakra-ui/icons'

import wisdom from "./assets/wisdom.svg";

import styled from "@emotion/styled";

const StyledImg = styled.img`
height:24px;
cursor:pointer;
`;

const StyledHeader = styled(Box)`
/* padding-left:80px; */
position:fixed;
x:0;
y:0;
top:0;
height:80px;
background-color:#2C5282;
width:100%;
`;
/*
<Link color={"yellow"} pl={"5px"} href={process.env.REACT_APP_PRIFINA_WISDOM_TERMS} isExternal>
Terms & Conditions
<ExternalLinkIcon mx='2px' />
</Link>
*/
const Header = ({ txts }) => {
  return <>

    <StyledHeader pl={[5, 5, 20, 20]}>
      <Flex h={"100%"} alignItems={"center"}>

        <StyledImg src={wisdom} onClick={() => {
          window.open(process.env.REACT_APP_PRIFINA_WISDOM_LOGO, '_blank');
        }} />
        <Spacer />
        <Link color={"white"} pr={[4, 4, 5, 5]} href={process.env.REACT_APP_PRIFINA_WISDOM_ABOUT} isExternal><InfoIcon /></Link>
        <Button size={["sm", "sm", "md"]} mr={[2, 2, 10, 10]} colorScheme='whatsapp' onClick={() => {
          window.open(process.env.REACT_APP_PRIFINA_WISDOM_BOOK_CALL, '_blank');

        }}>{txts.book}</Button>
      </Flex>
    </StyledHeader>
  </>
}

export default Header;